module.exports = __webpack_public_path__ + "static/media/s4.b59ba1cb.webp";